<app-notification></app-notification>
<div class=app>
  @if (!isLoginPage) {
    <header class=app__header>
      <div class="header__logo-box" (click)="onHome()">
        <img [src]="logo" alt="logo" class="header__logo">
      </div>
      <div class="header__tenant">
        @if (generalSearchLayoutItem) {
          <app-object-search [layoutItem]="generalSearchLayoutItem" [tenantCode]="tenantCode" class="header__search"></app-object-search>
        }
        @if (!generalSearchLayoutItem) {
          <span>{{ tenantName }}</span>
        }
      </div>
      @if (user) {
        <div class="header__account-info">
          <app-profile-menu></app-profile-menu>
        </div>
      }
    </header>
  }

  @if (navigation && !isLoginPage) {
    <nav class="app__navigation">
      @for (layout of navigation.layouts; track layout) {
        <div class="navigation" [class.navigation--text]="!layoutHasIcons(layout)">
          @for (layoutItem of layout.items; track layoutItem) {
            <a class="nav-link" [class.nav-link--icon]="getNavIcon(layoutItem)"
              (click)="onNavigate(layoutItem)" href="javascript:void(0)">
              @if (getNavIcon(layoutItem)) {
                <div class="nav-link__tooltip">{{ layoutItem.label }}</div>
                <svg class="icon icon--large">
                  <use [attr.xlink:href]="getNavIcon(layoutItem)"></use>
                </svg>
              } @else {
                {{ layoutItem.label }}
              }
            </a>
          }
        </div>
      }
    </nav>
  }

  <main class="app__main">
    <router-outlet></router-outlet>
  </main>
</div>